import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-39" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-40" data-mp="12qr3gleay4z2">
        <h2 id="closing-title" className="text-balance text-center font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-silver sm:text-5xl" data-id="element-41" data-mp="xthc307crj8l">
          Stop Struggling. <span className="text-gold" data-id="element-42" data-mp="17sgfa39cmmo7">Start Understanding.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-43" data-mp="1ljbojgnrf5sb">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border border-electric/25 border-l-4 border-l-electric bg-industrial px-4 py-3.5 text-sm font-semibold text-silver sm:text-base" data-id="element-44" data-mp="1hhq5teojnxa7" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-45" data-mp="2cajmr3nrfb1y" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}